module.exports = __webpack_public_path__ + "static/navigation_menu-062b1c92fa4963cfcb32547909eb3750.png";